import { initialRecommendedVehicles } from '~/constants/initialRecommendedVehicles';
import { VehicleTileSkeleton } from '../VehicleTile';

const LoadingVehicles = ({ error }: { error?: Error }) =>
  error ? null : (
    <>
      {[...Array(initialRecommendedVehicles)].map((_, index) => (
        <VehicleTileSkeleton key={`tile-loader-${index}`} />
      ))}
    </>
  );

export default LoadingVehicles;
